// types
import { TP_AirHandlingUnit } from './types'
// components
import { OutgoingAirPanel } from './OutgoingAirPanel'
import { FreshAirPanel } from './FreshAirPanel'
import { HeatRecoveryPanel } from './HeatRecoveryPanel';
import { SupplyAirPanel } from './SupplyAirPanel';
import { ExhaustAirPanel } from './ExhaustAirPanel';
import { LoadingView } from "../../../../components";
// api
import { useGetObjectsChildren } from '../../../../hooks/useGetObjectsChildren';
import { PlantSwitchesGrid } from '../../components/PlantSwitches';
import { OperationState } from './';
import { Block } from 'baseui/block';

export function OperatorPanel(props: TP_AirHandlingUnit) {
    const { children: childElement, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)

    return (
        <>
            <Block margin={'10px'} display={'flex'} justifyContent={'center'}>
                <OperationState {...props}></OperationState>
            </Block>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>

                <PlantSwitchesGrid childElements={childElement} ></PlantSwitchesGrid>

                <FreshAirPanel childElements={childElement}></FreshAirPanel>

                <HeatRecoveryPanel childElements={childElement}></HeatRecoveryPanel>

                <SupplyAirPanel childElements={childElement}></SupplyAirPanel>

                <ExhaustAirPanel childElements={childElement} />

                <OutgoingAirPanel childElements={childElement}></OutgoingAirPanel>


            </LoadingView >
        </>
    );
}






